import { SET_USER, AUTHENTICATION_FAILED } from './userActions';

const defaultState = {
    userId: undefined,
    userName: undefined,
    userType: undefined,
    authenticationFailed: false,
    aquaId: undefined,
    persistedUserId: undefined, // used to track change of user during non-landing page refresh
};

const userReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                userId: action.userId,
                userName: action.userName,
                userType: action.userType,
                aquaId: action.aquaId || state.aquaId,
                persistedUserId: action.userId,
            };
        case AUTHENTICATION_FAILED:
            return {
                ...state,
                userId: undefined,
                userName: undefined,
                authenticationFailed: true,
                persistedUserId: undefined,
            };
        default:
            return state;
    }
};

export default userReducer;
